import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ShopPage from "../pages/shop/page";
import ProductPage from "../pages/shop/product/page";
import OrderPage from "../pages/order/page";
import SteeringWheelPage from "../pages/steering-wheel/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/shop",
    element: <ShopPage />,
  },
  {
    path: "/shop/:brand",
    element: <ShopPage />,
  },
  {
    path: "/shop/:brand/:productId",
    element: <ProductPage />,
  },
  // Legacy redirect
  {
    path: "/products/:brand",
    element: <Navigate to="/shop" replace />,
  },
  {
    path: "/steering-wheel",
    element: <SteeringWheelPage />,
  },
  {
    path: "/order",
    element: <OrderPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
